import React from 'react';

import { ComparableObjectsTabProps } from './ValueReport.type';

import ValueReportComponentCard from './components/ValueReportComponentCard';
import { RouteComponentProps } from '@reach/router';
import TextEditor from './components/TextEditor';
import Icon from '~/components/Icon';

type Props = {
  /**  Id for tests */
  datatestId: string;

  /**  Tab text for current tab content */
  label: string;

  /** data contains: {
      mainHeader: { text },
    }
  */
  data: ComparableObjectsTabProps;

  /** Callback function which call data updating in container state */
  onChange: (objectName?: string) => (value: $Object) => void;
} & RouteComponentProps;

const text = {
  title: 'Swipen',
  mainText: 'Koptekst',
};

const ComparableObjectsTab = ({ data, datatestId, onChange }: Props) => {
  const { mainHeader } = data;
  return (
    <ValueReportComponentCard
      datatestId={datatestId}
      title={text.title}
      cardIcon={<Icon name="grid" />}
    >
      <TextEditor
        testName={'mainHeader'}
        text={mainHeader.text}
        title={text.mainText}
        onChange={value => onChange('mainHeader')({ text: value })}
        name="text"
        disabled={false}
      />
    </ValueReportComponentCard>
  );
};

export default ComparableObjectsTab;
